import { z } from 'zod'

import { IEmployee } from '@/types/user'
import { OFFICIAL_REPORT_FORM_FIELDS } from '../constant'
import { FormValuesType } from '../schema'

export const validateDriverEmployeeNumber = ({
    data,
    ctx,
    employees,
}: {
    data: FormValuesType
    ctx: z.RefinementCtx
    employees: IEmployee[]
}): string | undefined => {
    const driverEmployeeNumber = data[OFFICIAL_REPORT_FORM_FIELDS.driverEmployeeNumber]?.trim()

    const warningText = 'Driver not found, please check the employee number.'

    if (!driverEmployeeNumber) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: warningText,
            path: [OFFICIAL_REPORT_FORM_FIELDS.driverEmployeeNumber],
        })
        return
    }

    const foundedEmployee = employees.find((item) => item.badgeNumber === driverEmployeeNumber)

    if (!foundedEmployee) {
        return employees.length ? warningText : 'Driver check not available - you may be offline'
    }
}
